import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {PopulationUsageCollab} from "@domain/admin/entreprise/population/population-usage-collab";

/**
 * Composant d'affichage de la page affichant la liste de l'usage des collaborateurs
 *
 * @author Lionel Gimenez
 * @date 02/06/2025
 */
@Component({
    host: {'data-test-id': 'population-usage-collab'},
    templateUrl: './population-usage-collab.component.html'
})
export class PopulationUsageCollabComponent extends ListViewItem<PopulationUsageCollab> {
}